// extracted by mini-css-extract-plugin
export var actionButton = "_bj-1";
export var actionButtons = "_bj-2";
export var actions = "_bj-0";
export var aiUnread = "_bj-10";
export var alignCenter = "_bj-h";
export var backWrapper = "_bj-3";
export var cellContainer = "_bj-4";
export var checkboxContainer = "_bj-5";
export var contentContainer = "_bj-6";
export var contentHeader = "_bj-8";
export var conversationsTableWrapper = "_bj-s";
export var draftReplyBadgeContainer = "_bj-m";
export var dropdownItem = "_bj-b";
export var dropdownItemsContainer = "_bj-a";
export var dropdownTitle = "_bj-c";
export var errorIcon = "_bj-7";
export var filter = "_bj-d";
export var gray = "_bj-i";
export var headerActionButtons = "_bj-e";
export var headerCheckboxContainer = "_bj-f";
export var icon = "_bj-j";
export var menuContainer = "_bj-k";
export var noMoreTicketsIcon = "_bj-12";
export var noMoreTicketsSubText = "_bj-13";
export var oneLine = "_bj-l";
export var optionsButton = "_bj-n";
export var plus = "_bj-o";
export var portalButtonsWrapper = "_bj-g";
export var red = "_bj-p";
export var scrolledTop = "_bj-9";
export var search = "_bj-q";
export var selectedConversationsCount = "_bj-r";
export var spinner = "_bj-t";
export var strong = "_bj-u";
export var summaryCell = "_bj-v";
export var tableContainer = "_bj-11";
export var tagContainer = "_bj-w";
export var threeDots = "_bj-x";
export var twoLines = "_bj-y";
export var unread = "_bj-z";